import { __extends } from "tslib";
/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { alCoerceString, alIsFunction } from '../runtime';
import { wrapAVM1NativeClass } from './AVM1Utils';
import { AVM1Object } from '../runtime/AVM1Object';
//module Shumway.AVM1.Lib {
var AVM1ExternalInterface = /** @class */ (function (_super) {
    __extends(AVM1ExternalInterface, _super);
    function AVM1ExternalInterface() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AVM1ExternalInterface.createAVM1Class = function (context) {
        return wrapAVM1NativeClass(context, true, AVM1ExternalInterface, ['available#', 'addCallback', 'call'], []);
    };
    AVM1ExternalInterface.getAvailable = function (context) {
        return true; //context.sec.flash.external.ExternalInterface.axClass.available;
    };
    AVM1ExternalInterface.addCallback = function (context, methodName, instance, method) {
        methodName = alCoerceString(context, methodName);
        if (!alIsFunction(method)) {
            return false;
        }
        try {
            if (!window['flashObject']) {
                window['flashObject'] = {};
            }
            window['flashObject'][methodName] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var desc = instance.alGet(methodName.toLowerCase());
                if (desc && alIsFunction(desc))
                    desc.alCall(instance, args);
                else if (desc && desc.value)
                    desc.value.alCall(instance, args);
                //_this.mwAdaptee.runScripts();
            };
            /*context.sec.flash.external.ExternalInterface.axClass.addCallback(methodName, function () {
                var args = Array.prototype.slice.call(arguments, 0);
                var result = context.executeFunction(method, instance, args);
                return result;
            });*/
            return true;
        }
        catch (e) {
            console.warn('[AVM1ExternalInterface] - error in addCallback', e);
        }
        return false;
    };
    AVM1ExternalInterface.call = function (context, methodName) {
        var parameters = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            parameters[_i - 2] = arguments[_i];
        }
        var args = []; // [alCoerceString(context, methodName)];
        var paramsLength = parameters.length;
        var i = 0;
        for (i = 0; i < paramsLength; i++) {
            // TODO convert AVM1 objects to AVM2
            args.push(parameters[i]);
        }
        if (args.length == 1) {
            args = args[0];
        }
        try {
            var methodnames = methodName.split('.');
            var method = window;
            for (i = 0; i < methodnames.length; i++) {
                method = method[methodnames[i]];
            }
            method(args);
            /*var result = context.sec.flash.external.ExternalInterface.axClass.call.apply(
                context.sec.flash.external.ExternalInterface.axClass, args);
                */
            var result = '';
            // TODO convert AVM2 result to AVM1
            return result;
        }
        catch (e) {
            return undefined;
        }
    };
    return AVM1ExternalInterface;
}(AVM1Object));
export { AVM1ExternalInterface };
